package com.example.borshi.web.account

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import com.example.borshi.web.firebase.FirebaseService
import com.example.borshi.web.firebase.SavedAddress
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxHeight
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

// SavedAddress is now imported from FirebaseService

@Composable
fun ManageAddressesScreen(@Suppress("UNUSED_PARAMETER") onBack: () -> Unit) {
    var addresses by remember { mutableStateOf<List<SavedAddress>>(emptyList()) }
    var showAddDialog by remember { mutableStateOf(false) }
    var editingAddress by remember { mutableStateOf<SavedAddress?>(null) }
    var deleteDialogAddress by remember { mutableStateOf<SavedAddress?>(null) }
    var isLoading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        try {
            isLoading = true
            error = null
            console.log("Starting to fetch addresses...")
            addresses = FirebaseService.getAddresses()
            console.log("Fetched addresses:", addresses.size)
            isLoading = false
        } catch (e: Throwable) {
            console.error("Failed to load addresses:", e)
            error = "Failed to load addresses: ${e.message}"
            isLoading = false
        }
    }

    Div({
        style {
            maxWidth(1000.px)
            property("margin", "0 auto")
            padding(24.px, 16.px)
            width(100.percent)
            backgroundColor(Color("#F5F5F5"))
            minHeight(100.vh)
        }
    }) {
        // Header
        Div({
            style {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                marginBottom(24.px)
            }
        }) {
            H1({
                style {
                    fontSize(28.px)
                    fontWeight("bold")
                    color(Color("#0D2B2E"))
                    margin(0.px)
                }
            }) {
                Text("My Addresses")
            }

            Button({
                style {
                    backgroundColor(Color("#D11243"))
                    color(Color.white)
                    padding(12.px, 24.px)
                    borderRadius(8.px)
                    border(0.px)
                    fontSize(14.px)
                    fontWeight("600")
                    cursor("pointer")
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(8.px)
                }
                onClick {
                    editingAddress = null
                    showAddDialog = true
                }
            }) {
                Text("+ Add New Address")
            }
        }

        // Content
        when {
            isLoading -> {
                // Loading State
                Div({
                    style {
                        backgroundColor(Color.white)
                        padding(60.px, 40.px)
                        borderRadius(16.px)
                        textAlign("center")
                        property("box-shadow", "0 2px 8px rgba(0,0,0,0.1)")
                    }
                }) {
                    Div({ style { fontSize(48.px); marginBottom(16.px) } }) {
                        Text("⏳")
                    }
                    P({ style { fontSize(16.px); color(Color("#757575")) } }) {
                        Text("Loading addresses...")
                    }
                }
            }
            error != null -> {
                // Error State
                Div({
                    style {
                        backgroundColor(Color("#FFEBEE"))
                        padding(20.px)
                        borderRadius(16.px)
                        textAlign("center")
                        property("box-shadow", "0 2px 8px rgba(0,0,0,0.1)")
                    }
                }) {
                    Div({ style { fontSize(48.px); marginBottom(16.px) } }) {
                        Text("⚠️")
                    }
                    P({ style { fontSize(16.px); color(Color("#D32F2F")); marginBottom(16.px) } }) {
                        Text(error ?: "Unknown error")
                    }
                    Button({
                        style {
                            backgroundColor(Color("#26A69A"))
                            color(Color.white)
                            padding(10.px, 20.px)
                            border(0.px)
                            borderRadius(8.px)
                            fontSize(14.px)
                            cursor("pointer")
                        }
                        onClick {
                            scope.launch {
                                try {
                                    isLoading = true
                                    error = null
                                    addresses = FirebaseService.getAddresses()
                                    isLoading = false
                                } catch (e: Throwable) {
                                    error = "Failed to load addresses: ${e.message}"
                                    isLoading = false
                                }
                            }
                        }
                    }) {
                        Text("Retry")
                    }
                }
            }
            addresses.isEmpty() -> {
            // Empty State
            Div({
                style {
                    backgroundColor(Color.white)
                    padding(60.px, 40.px)
                    borderRadius(16.px)
                    textAlign("center")
                    property("box-shadow", "0 2px 8px rgba(0,0,0,0.1)")
                }
            }) {
                Div({ style { fontSize(64.px); marginBottom(16.px) } }) {
                    Text("📍")
                }
                H3({
                    style {
                        fontSize(24.px)
                        fontWeight("bold")
                        color(Color("#0D2B2E"))
                        marginBottom(8.px)
                    }
                }) {
                    Text("No addresses yet")
                }
                P({
                    style {
                        fontSize(16.px)
                        color(Color("#757575"))
                        lineHeight("1.6")
                        marginBottom(24.px)
                    }
                }) {
                    Text("Add your first delivery address to get started")
                }
            }
        }
            else -> {
            // Addresses Grid
            Div({
                style {
                    display(DisplayStyle.Grid)
                    property("grid-template-columns", "repeat(auto-fill, minmax(350px, 1fr))")
                    gap(16.px)
                }
            }) {
                addresses.forEach { address ->
                    AddressCard(
                        address = address,
                        onEdit = {
                            editingAddress = address
                            showAddDialog = true
                        },
                        onDelete = {
                            deleteDialogAddress = address
                        },
                        onSetDefault = {
                            scope.launch {
                                try {
                                    FirebaseService.setDefaultAddress(address.id)
                                    addresses = FirebaseService.getAddresses()
                                } catch (e: Throwable) {
                                    console.error("Error setting default address:", e)
                                }
                            }
                        }
                    )
                }
            }
        }
        }

        // Add/Edit Dialog
        if (showAddDialog) {
            AddEditAddressDialog(
                address = editingAddress,
                onDismiss = { showAddDialog = false },
                onSave = { newAddress ->
                    scope.launch {
                        try {
                            FirebaseService.saveAddress(newAddress)
                            addresses = FirebaseService.getAddresses()
                        } catch (e: Throwable) {
                            console.error("Error saving address:", e)
                        }
                    }
                    showAddDialog = false
                }
            )
        }

        // Delete Confirmation Dialog
        deleteDialogAddress?.let { address ->
            DeleteConfirmationDialog(
                addressName = address.name,
                onConfirm = {
                    scope.launch {
                        try {
                            if (address.id.isNotBlank()) {
                                FirebaseService.deleteAddress(address.id)
                                addresses = FirebaseService.getAddresses()
                            }
                        } catch (e: Throwable) {
                            console.error("Error deleting address:", e)
                        }
                    }
                    deleteDialogAddress = null
                },
                onDismiss = { deleteDialogAddress = null }
            )
        }
    }
}

@Composable
fun AddressCard(
    address: SavedAddress,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onSetDefault: () -> Unit
) {
    Div({
        style {
            backgroundColor(Color.white)
            borderRadius(12.px)
            padding(20.px)
            property("box-shadow", "0 2px 8px rgba(0,0,0,0.1)")
            position(Position.Relative)
            property("transition", "all 0.3s ease")
            if (address.isDefault) {
                border(2.px, LineStyle.Solid, Color("#4CAF50"))
            }
        }
        onMouseEnter { event ->
            event.currentTarget.asDynamic().style.boxShadow = "0 4px 16px rgba(0,0,0,0.15)"
        }
        onMouseLeave { event ->
            event.currentTarget.asDynamic().style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)"
        }
    }) {
        // Default Badge
        if (address.isDefault) {
            Div({
                style {
                    position(Position.Absolute)
                    top(12.px)
                    right(12.px)
                    backgroundColor(Color("#4CAF50"))
                    color(Color.white)
                    padding(4.px, 10.px)
                    borderRadius(12.px)
                    fontSize(11.px)
                    fontWeight("600")
                }
            }) {
                Text("DEFAULT")
            }
        }

        // Address Name
        H4({
            style {
                fontSize(18.px)
                fontWeight("bold")
                color(Color("#0D2B2E"))
                marginBottom(12.px)
            }
        }) {
            Text(address.name)
        }

        // Address Details
        P({
            style {
                fontSize(14.px)
                color(Color("#212121"))
                lineHeight("1.6")
                marginBottom(8.px)
            }
        }) {
            Text(address.line1)
        }

        if (address.line2.isNotEmpty()) {
            P({
                style {
                    fontSize(14.px)
                    color(Color("#212121"))
                    lineHeight("1.6")
                    marginBottom(8.px)
                }
            }) {
                Text(address.line2)
            }
        }

        P({
            style {
                fontSize(14.px)
                color(Color("#212121"))
                marginBottom(8.px)
            }
        }) {
            Text("${address.city}, ${address.state} - ${address.postalCode}")
        }

        if (address.phone.isNotEmpty()) {
            P({
                style {
                    fontSize(14.px)
                    color(Color("#757575"))
                    marginBottom(4.px)
                }
            }) {
                Text("📞 ${address.phone}")
            }
        }

        if (address.email.isNotEmpty()) {
            P({
                style {
                    fontSize(14.px)
                    color(Color("#757575"))
                    marginBottom(16.px)
                }
            }) {
                Text("📧 ${address.email}")
            }
        }

        // Action Buttons
        Div({
            style {
                display(DisplayStyle.Flex)
                gap(8.px)
                paddingTop(12.px)
                property("border-top", "1px solid #E0E0E0")
            }
        }) {
            if (!address.isDefault) {
                Button({
                    style {
                        flex(1)
                        padding(8.px)
                        backgroundColor(Color("#E8F5E9"))
                        color(Color("#2E7D32"))
                        border(0.px)
                        borderRadius(6.px)
                        fontSize(13.px)
                        fontWeight("600")
                        cursor("pointer")
                    }
                    onClick { onSetDefault() }
                }) {
                    Text("Set as Default")
                }
            }

            Button({
                style {
                    flex(1)
                    padding(8.px)
                    backgroundColor(Color("#E3F2FD"))
                    color(Color("#1976D2"))
                    border(0.px)
                    borderRadius(6.px)
                    fontSize(13.px)
                    fontWeight("600")
                    cursor("pointer")
                }
                onClick { onEdit() }
            }) {
                Text("✏️ Edit")
            }

            Button({
                style {
                    flex(1)
                    padding(8.px)
                    backgroundColor(Color("#FFEBEE"))
                    color(Color("#C62828"))
                    border(0.px)
                    borderRadius(6.px)
                    fontSize(13.px)
                    fontWeight("600")
                    cursor("pointer")
                }
                onClick { onDelete() }
            }) {
                Text("🗑️ Delete")
            }
        }
    }
}

@Composable
fun AddEditAddressDialog(
    address: SavedAddress?,
    onDismiss: () -> Unit,
    onSave: (SavedAddress) -> Unit
) {
    var name by remember { mutableStateOf(address?.name ?: "") }
    var phone by remember { mutableStateOf(address?.phone ?: "") }
    var email by remember { mutableStateOf(address?.email ?: "") }
    var line1 by remember { mutableStateOf(address?.line1 ?: "") }
    var line2 by remember { mutableStateOf(address?.line2 ?: "") }
    var city by remember { mutableStateOf(address?.city ?: "Kolkata") }
    var state by remember { mutableStateOf(address?.state ?: "West Bengal") }
    var postalCode by remember { mutableStateOf(address?.postalCode ?: "") }

    // Pre-fill from user profile when creating a new address
    if (address == null) {
        LaunchedEffect(Unit) {
            try {
                val profile = com.example.borshi.web.firebase.FirebaseService.getUserProfile()
                if (name.isBlank()) name = profile.name ?: ""
                if (phone.isBlank()) phone = profile.phoneNumber ?: ""
                if (email.isBlank()) email = profile.email ?: ""
            } catch (_: Throwable) {}
        }
    }

    // Modal Overlay
    Div({
        style {
            position(Position.Fixed)
            top(0.px)
            left(0.px)
            right(0.px)
            bottom(0.px)
            backgroundColor(Color("rgba(0, 0, 0, 0.5)"))
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            property("z-index", "1000")
            padding(20.px)
        }
        onClick { onDismiss() }
    }) {
        // Dialog
        Div({
            style {
                backgroundColor(Color.white)
                borderRadius(16.px)
                padding(32.px)
                maxWidth(600.px)
                width(100.percent)
                maxHeight(90.vh)
                overflowY("auto")
            }
            onClick { event -> event.stopPropagation() }
        }) {
            H2({
                style {
                    fontSize(24.px)
                    fontWeight("bold")
                    color(Color("#0D2B2E"))
                    marginBottom(24.px)
                }
            }) {
                Text(if (address != null) "Edit Address" else "Add New Address")
            }

            // Form
            Div({
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(16.px)
                }
            }) {
                AddressFormField("Full Name *", name) { name = it }
                AddressFormField("Phone Number *", phone) { phone = it }
                AddressFormField("Email Address *", email) { email = it }
                AddressFormField("Address Line 1 *", line1) { line1 = it }
                AddressFormField("Address Line 2 (Optional)", line2) { line2 = it }

                Div({
                    style {
                        display(DisplayStyle.Grid)
                        property("grid-template-columns", "1fr 1fr")
                        gap(16.px)
                    }
                }) {
                    AddressFormField("City *", city) { city = it }
                    AddressFormField("State", state) { state = it }
                }

                Div({
                    style {
                        display(DisplayStyle.Grid)
                        property("grid-template-columns", "1fr 1fr")
                        gap(16.px)
                    }
                }) {
                    AddressFormField("Postal Code *", postalCode) { postalCode = it }
                }
            }

            // Buttons
            Div({
                style {
                    display(DisplayStyle.Flex)
                    gap(12.px)
                    marginTop(24.px)
                }
            }) {
                Button({
                    style {
                        flex(1)
                        padding(12.px)
                        backgroundColor(Color("#E0E0E0"))
                        color(Color("#212121"))
                        border(0.px)
                        borderRadius(8.px)
                        fontSize(16.px)
                        fontWeight("600")
                        cursor("pointer")
                    }
                    onClick { onDismiss() }
                }) {
                    Text("Cancel")
                }

                Button({
                    style {
                        flex(1)
                        padding(12.px)
                        backgroundColor(Color("#D11243"))
                        color(Color.white)
                        border(0.px)
                        borderRadius(8.px)
                        fontSize(16.px)
                        fontWeight("600")
                        cursor("pointer")
                    }
                    onClick {
                        if (name.isNotBlank() && phone.isNotBlank() && email.isNotBlank()
                            && line1.isNotBlank() && city.isNotBlank() && postalCode.isNotBlank()) {
                            onSave(SavedAddress(
                                id = address?.id ?: "",
                                name = name,
                                phone = phone,
                                email = email,
                                line1 = line1,
                                line2 = line2,
                                city = city,
                                state = state,
                                postalCode = postalCode,
                                isDefault = address?.isDefault ?: false
                            ))
                        } else {
                            window.alert("Please fill all required fields: Name, Phone, Email, Address Line 1, City, and Postal Code")
                        }
                    }
                }) {
                    Text("Save Address")
                }
            }
        }
    }
}

@Composable
fun AddressFormField(label: String, value: String, onValueChange: (String) -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(6.px)
        }
    }) {
        Label(forId = null, attrs = {
            style {
                fontSize(14.px)
                fontWeight("500")
                color(Color("#212121"))
            }
        }) {
            Text(label)
        }

        Input(InputType.Text) {
            value(value)
            onInput { onValueChange(it.value) }
            style {
                padding(10.px)
                borderRadius(6.px)
                border(1.px, LineStyle.Solid, Color("#E0E0E0"))
                fontSize(14.px)
                width(100.percent)
            }
        }
    }
}

@Composable
fun DeleteConfirmationDialog(
    addressName: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit
) {
    // Modal Overlay
    Div({
        style {
            position(Position.Fixed)
            top(0.px)
            left(0.px)
            right(0.px)
            bottom(0.px)
            backgroundColor(Color("rgba(0, 0, 0, 0.5)"))
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            property("z-index", "1000")
        }
        onClick { onDismiss() }
    }) {
        // Dialog
        Div({
            style {
                backgroundColor(Color.white)
                borderRadius(16.px)
                padding(32.px)
                maxWidth(400.px)
                width(100.percent)
            }
            onClick { event -> event.stopPropagation() }
        }) {
            H3({
                style {
                    fontSize(20.px)
                    fontWeight("bold")
                    color(Color("#0D2B2E"))
                    marginBottom(12.px)
                }
            }) {
                Text("Delete Address?")
            }

            P({
                style {
                    fontSize(16.px)
                    color(Color("#757575"))
                    lineHeight("1.6")
                    marginBottom(24.px)
                }
            }) {
                Text("Are you sure you want to delete \"$addressName\"? This action cannot be undone.")
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    gap(12.px)
                }
            }) {
                Button({
                    style {
                        flex(1)
                        padding(12.px)
                        backgroundColor(Color("#E0E0E0"))
                        color(Color("#212121"))
                        border(0.px)
                        borderRadius(8.px)
                        fontSize(16.px)
                        fontWeight("600")
                        cursor("pointer")
                    }
                    onClick { onDismiss() }
                }) {
                    Text("Cancel")
                }

                Button({
                    style {
                        flex(1)
                        padding(12.px)
                        backgroundColor(Color("#F44336"))
                        color(Color.white)
                        border(0.px)
                        borderRadius(8.px)
                        fontSize(16.px)
                        fontWeight("600")
                        cursor("pointer")
                    }
                    onClick { onConfirm() }
                }) {
                    Text("Delete")
                }
            }
        }
    }
}
